module.exports = __webpack_public_path__ + "bb884a2839cfca88a778127a1878b8d2.MP3";